import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from 'components/common';
import { UpgradeLicense } from 'utils/constants';
import { format } from 'utils/date';
import { useAuth, useDefaultCategories } from 'hooks';
import {
  setExternalSearch,
  setView,
  setFilterSectionIsCollapsed,
} from 'actions/search';
import licenseType from 'models/licenseType';

const ViewContactsButton = ({ name, date }) => {
  const dispatch = useDispatch();
  const { push } = useHistory();
  const tradeshow = {
    label: date ? `${name} - ${format(date, 'YYYY')}` : name,
    date,
  };

  const { hasLicense, user } = useAuth();
  const searchCategories = useDefaultCategories();
  const handleSearch = () => {
    if (
      hasLicense(
        [
          licenseType.temporaryOld,
          licenseType.legacy,
          licenseType.academic,
          licenseType.industry,
        ],
        true
      )
    ) {
      dispatch(setView('researcher'));
    }

    const search = {
      term: '*',
      tradeshow: [tradeshow],
      // Tradeshows stays on whatever the user's defaults say: thisShowOnly only matches tradeshow items.
      category: { ...searchCategories, tradeshows: true },
      date: 'all',
      thisShowOnly: true,
    };
    dispatch(setExternalSearch(search));
    dispatch(setFilterSectionIsCollapsed('tradeshows', false));
    push('/');
  };

  return (
    <Button
      disabled={user.isPartnerAccount}
      tooltip={user.isPartnerAccount ? <UpgradeLicense /> : ''}
      onClick={handleSearch}
      size='small'
    >
      View Contacts
    </Button>
  );
};

export default ViewContactsButton;
